// Initial state
function initialState() {
	return {
		customerNotes: '',
		focusNotes: '',
		customAddress: '',
		promoCode: ''
	}
}

const state = initialState()

// Getters
const getters = {
	cxNotes: (state) => {
		return state.customerNotes
	},
	foNotes: (state) => {
		return state.focusNotes
	},
	customAddress: (state) => {
		return state.customAddress
	},
	promoCode: (state) => {
		return state.promoCode
	}
}

// Actions
const actions = {
	resetState ({ state, commit }) {
		commit('reset')
	},
	addCustomerNotes ({ state, commit }, notes) {
		commit('setCustomerNotes', notes)
	},
	addFocusNotes ({ state, commit }, notes) {
		commit('setFocusNotes', notes)
	},
	addCustomAddress ({ state, commit }, notes) {
		commit('setCustomAddress', notes)
	},
	addPromoCode ({ state, commit }, notes) {
		commit('setPromoCode', notes)
	}
}

// Mutations
const mutations = {
	reset (state) {
		// acquire initial state
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	setCustomerNotes (state, notes) {
		state.customerNotes = notes
	},
	setFocusNotes (state, notes) {
		state.focusNotes = notes
	},
	setCustomAddress (state, notes) {
		state.customAddress = notes
	},
	setPromoCode (state, notes) {
		state.promoCode = notes
	}
}

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
}
